import { Evaluation, useIsMobile } from '@yes.technology/react-toolkit'
import { ActivityModel } from 'types/shared'
import { ActivityInputProps } from '../Activity.types'

type ActivityEvaluationProps = {
  value: ActivityModel['value']
  onChange: ActivityInputProps['handleChange']
} & Pick<
  React.ComponentProps<typeof Evaluation>,
  'title' | 'subtitle' | 'direction' | 'informational'
>

const ActivityEvaluation = ({
  value,
  onChange,
  direction,
  ...props
}: ActivityEvaluationProps) => {
  const isMobile = useIsMobile()

  const handleChange = (rating: number) => {
    onChange(`${rating}`)
  }

  const formattedValue =
    typeof value === 'string' ? Number(value) : Number(value?.des)

  const defaultDirection = isMobile ? 'vertical' : 'horizontal'

  return (
    <Evaluation
      heightClass='regular'
      onChange={handleChange}
      direction={direction || defaultDirection}
      value={formattedValue}
      {...props}
    />
  )
}

export default ActivityEvaluation
